<template>
  <p v-if="!isProduction">
    No component mapping found for type: {{ componentData.typeCode }} | uid: {{ componentData.uid }}
  </p>
</template>
<script>
import {mapState} from 'vuex';
export default {
  props: {
    componentData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('backend', ['isProduction']),
  },
};
</script>
